const styles = '*{box-sizing:border-box}slot{display:block}slot[name=primary-button]{order:var(--primary-order,2)}slot[name=secondary-button]{order:var(--secondary-order,0)}:host([primary-lead]){--primary-order:0;--secondary-order:2}.gap{height:.75rem;order:1;width:.75rem}slot[name=secondary-button]:not([visible]),slot[name=secondary-button]:not([visible])+.gap{display:none}.footer{display:flex;flex-direction:column;padding:1.5rem 1rem}skapa-button,slot::slotted(*){width:100%}:host([compact]) .footer{flex-direction:row}:host([compact]) .footer slot{flex:1 50%}:host([border]) .footer{border-block-start:1px solid rgb(var(--colour-neutral-3,223,223,223))}@media (min-width:37.5em){:host .footer{padding:1.5rem}:host slot{flex-basis:50%}:host(:not([small])) .footer{flex-direction:row;justify-content:var(--skapa-modal-footer-alignment,flex-start)}:host(:not([small])) slot{flex-grow:1}:host(:not([small])) slot[name=secondary-button]:not([visible])~slot,:host([auto-size]) slot{flex:initial}.gap{height:1rem;width:1rem}}@media (orientation:landscape){.footer{flex-direction:row}:host([stacked][small]) .footer{flex-direction:column}slot{flex-grow:1}}';
import { SkapaElement } from "@ingka/skapa-webc-element";
import {
  SlotTools,
  BreakpointInfo
} from "@ingka/webc-tools";
import { Button } from "@ingka/button-webc/passive.js";
function generateTemplate({ html }) {
  const template = document.createElement("template");
  template.innerHTML = html`
    <style>
      ${styles}
    </style>
    <div class="footer">
      <slot name="secondary-button">
        <skapa-button variant="secondary">
          <slot name="secondary" role="none"></slot>
        </skapa-button>
      </slot>
      <div class="gap" aria-hidden="true"></div>
      <slot name="primary-button">
        <skapa-button variant="primary">
          <slot role="none"></slot>
        </skapa-button>
      </slot>
    </div>
  `;
  return { main: template };
}
class ModalFooter extends SkapaElement {
  constructor() {
    super();
    this.handleSlotChange = (ev) => {
      const target = ev.target;
      SlotTools.slotChange(ev);
      if (target.name === "secondary") {
        this.checkSecondary();
      }
      updateButtons(this);
    };
    this.checkSecondary = () => {
      const hasTitle = !this.secondaryButtonSlot.querySelector("slot").classList.contains("skapa-empty");
      const assignedElements = this.secondaryButtonSlot.assignedElements().length;
      this.secondaryButtonSlot.toggleAttribute(
        "visible",
        Boolean(assignedElements || hasTitle)
      );
    };
    this.handleInteraction = (ev) => {
      const composedPath = ev.composedPath();
      if (composedPath.includes(this.primaryButtonSlot)) {
        this.dispatchEvent(new Event("primary"));
      } else if (composedPath.includes(this.secondaryButtonSlot)) {
        this.dispatchEvent(new Event("secondary"));
      }
    };
    this.handleBreakpointChange = () => {
      updateButtons(this);
    };
    const shadow = this.attachShadow({ mode: "open" });
    const template = this.getTemplates(generateTemplate);
    shadow.append(template.main.content.cloneNode(true));
    this.gatherProperties(
      ["small", "autoSize", "compact", "primaryLead", "stacked"],
      this
    );
    this.primaryButtonSlot = shadow.querySelector(
      "[name=primary-button]"
    );
    this.secondaryButtonSlot = shadow.querySelector(
      "[name=secondary-button]"
    );
  }
  connectedCallback() {
    super.connectedCallback();
    this.shadowRoot.addEventListener("slotchange", this.handleSlotChange);
    this.addEventListener("click", this.handleInteraction);
    Array.from(this.shadowRoot.querySelectorAll("slot")).map(
      SlotTools.checkSlot
    );
    this.checkSecondary();
    BreakpointInfo.addBreakpointListener(this.handleBreakpointChange);
    updateButtons(this);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener("click", this.handleInteraction);
    BreakpointInfo.removeBreakpointListener(this.handleBreakpointChange);
  }
  get small() {
    return this.hasAttribute("small");
  }
  set small(small) {
    this.toggleAttribute("small", !!small);
  }
  get autoSize() {
    return this.hasAttribute("auto-size");
  }
  set autoSize(toggle) {
    this.toggleAttribute("auto-size", !!toggle);
  }
  get compact() {
    return this.hasAttribute("compact");
  }
  set compact(toggle) {
    this.toggleAttribute("compact", !!toggle);
  }
  get primaryLead() {
    return this.hasAttribute("primary-lead");
  }
  set primaryLead(toggle) {
    this.toggleAttribute("primary-lead", !!toggle);
  }
  get stacked() {
    return this.hasAttribute("stacked");
  }
  set stacked(toggle) {
    this.toggleAttribute("stacked", !!toggle);
  }
}
ModalFooter.skapaTagName = "modal-footer";
ModalFooter.skapaDependencies = [Button];
function updateButtons(host) {
  const isSmall = BreakpointInfo.getCurrentBreakpoint() === "sm";
  const buttonTag = host.getPrefixedTagName(Button.skapaTagName);
  [
    ...Array.from(host.querySelectorAll(buttonTag)),
    ...Array.from(host.shadowRoot.querySelectorAll(buttonTag))
  ].forEach((button) => {
    if (isSmall) {
      button.setAttribute("size", "small");
    } else {
      button.removeAttribute("size");
    }
  });
}
export {
  ModalFooter
};
